import { render } from "./About.vue?vue&type=template&id=2a77f814"
const script = {}
script.render = render

export default script